import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function ArrayElementsEqualLengthValidator(min: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (control.value) {
      let length = control.value.split(/[, ;\n]+/).filter(v => v.length > 0)[0].length;
      return control.value.split(/[, ;\n]+/).filter(v => v.length != length).length != 0 ? { 'appArrayElementsEqualLength': { value: control.value } } : null;
    } else {
      return null;
    }
  };
}

@Directive({
  selector: '[appArrayElementsEqualLength]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ArrayElementsEqualLengthDirective, multi: true }]
})
export class ArrayElementsEqualLengthDirective {
  @Input('appArrayElementsEqualLength') min: number;

  validate(control: AbstractControl): { [key: string]: any } {
    return this.min ? ArrayElementsEqualLengthValidator(this.min)(control)
      : null;
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {

    if ('min' in changes) {

      if (this._onChange) this._onChange();
    }
  }

}
